// Analytics/TabContent.jsx
import React from 'react';
import { Typography } from '@mui/material';
import { analyticsTabs } from './config/analyticsConfig';
import OutpatientsTab from './tabs/OutpatientsTab';
import { IDepartment } from '../../../constants/types';
import InpatientsTab from './tabs/InpatientsTab';
import LabTab from './tabs/LabTab';
import RadiologyTab from './tabs/RadiologyTab';
import FinancesTab from './tabs/FinancesTab';
import ClinicalTab from './tabs/ClinicalTab';
import StudiesTab from './tabs/StudiesTab';

interface TabContentProps {
  tabNumber: number;
  tabs?: { id: string; [key: string]: any }[];
  loading: boolean;
  // Timestamps (ms) from the page DatesSelector, or null before a range is picked.
  startDate: number | null;
  endDate: number | null;
  investigation: {
    uuid: string;
    permissions: string[];
    [key: string]: any;
  };
  departmentSelected: string;
  departments: IDepartment[];
}

const TabContent: React.FC<TabContentProps> = ({
  tabNumber,
  tabs = analyticsTabs,
  loading,
  startDate,
  endDate,
  investigation,
  departmentSelected,
  departments
}) => {
  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  if (!tabs.length) {
    return <Typography>No analytics sections are available for this investigation.</Typography>;
  }

  const currentTabData = tabs[tabNumber];

  const commonProps = {
    investigation,
    departmentSelected,
    startDate,
    endDate,
    departments,
    tabNumber
  };

  switch (currentTabData?.id) {
    case 'outpatients':
      return <OutpatientsTab {...commonProps} />;
    case 'inpatients':
      return <InpatientsTab {...commonProps} />;
    case 'laboratory':
      return <LabTab {...commonProps} />;
    case 'radiology':
      return <RadiologyTab {...commonProps} />;
    case 'finances':
      return <FinancesTab {...commonProps} />;
    case 'clinical':
      return <ClinicalTab investigation={investigation} startDate={startDate} endDate={endDate} />;
    case 'studies':
      return <StudiesTab startDate={startDate} endDate={endDate} />;
    default:
      return <Typography>No data available for this tab.</Typography>;
  }
};

export default TabContent;
